import api from '../../utils/axios';

const locationByID = async (id) => {
	const { data } = await api.get(`/locations/${id}`);

	return data;
};

const locationService = { locationByID };

export default locationService;
